<div class="withdraw-status">
  <app-ds-rounded-icon size="large" variant="{{ statusContent.type }}" icon="{{ statusContent.icon }}"></app-ds-rounded-icon>
  <h2 class="ds-heading-1">{{ statusContent.title | translate }}</h2>
  <p class="ds-ui-2 ds-color-core-neutral-8" *ngIf="statusContent.desc.length > 0">{{ statusContent.desc | translate }}</p>
</div>
<div *ngIf="showFeedbackLoop" class="withdraw-feedback">
  <app-ds-feedback-loop [showLink]="false" feedbackSource="Withdrawal" (trackFeedback)="onTrackFeedback($event)">
    {{ 'ACCOUNT.withdrawalV2.success.liteNPS.heading' | translate }}
  </app-ds-feedback-loop>
</div>
<app-ds-button *ngIf="isMobileApp" (clicked)="onOpenProfile()">{{
  (withdrawalStatus === 'canceled' || withdrawalStatus === 'promotion' ? 'ACCOUNT.withdrawalV2.emotionalization.thankYou.buttonClose' : 'ACCOUNT.withdrawalV2.buttons.returnToProfile')
    | translate
}}</app-ds-button>
